import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';

import { TokenService } from '../token/token.service';

@Injectable()
export abstract class BaseHttpService {
  protected baseUrl: string;
  protected apiVersion: number;

  constructor(private tokenService: TokenService) {
    this.baseUrl = this.newBaseUrl;
    this.apiVersion = environment.apiVersion;
  }

  get newBaseUrl(): string {
    return sessionStorage.getItem('newBaseUrl') || environment.baseUrl;
  }

  get headers(): HttpHeaders {
    return new HttpHeaders()
      .set('Accept', 'application/json')
      .append('Cache-Control', 'no-cache')
      .append('Pragma', 'no-cache');
  }

  get authHeaders(): HttpHeaders {
    let token = this.tokenService.getToken();
    if (token !== undefined && token !== null && token !== '') {
      return this.headers.set('Authorization', 'Bearer ' + token);
    }

    return this.headers;
  }

  get customAuthHeaders(): HttpHeaders {
    const idToken = this.tokenService.getIdToken();
    const accessToken = this.tokenService.getToken();

    let headers = this.headers;

    if (idToken && accessToken) {
      headers = headers.set('Authorization', 'Bearer ' + accessToken).set('X-ID-Token', idToken);

      return headers;
    }

    return this.headers;
  }
}
